// extracted by mini-css-extract-plugin
export var settingsList = "_3d-0";
export var settingsRow = "_3d-1";
export var warningDot = "_3d-2";